export const LABELS = {
  BREADCRUMBS: [['page.documentation.breadcrumbs', 'Documentation']],
  PAGE_TITLE: ['page.documentation.title', 'Account Settings'],
};
